// extracted by mini-css-extract-plugin
module.exports = {"registerForm":"styles_registerForm__OIrjV","skinLogo":"styles_skinLogo__2aOn9","item":"styles_item__1wfzP","buttons":"styles_buttons__1m2oE"};